// Lets a host page (sales task form) confirm before the open popup for one user sends.
// Absent entry = send immediately, so every other page is unaffected.
export type SendGuard = (run: () => void) => void;

const guards = new Map<string, SendGuard>();

// Returns an unregister fn; only removes its own entry so a newer registration survives.
export function registerChatSendGuard(otherUserId: string, guard: SendGuard): () => void {
  guards.set(otherUserId, guard);
  return () => {
    if (guards.get(otherUserId) === guard) guards.delete(otherUserId);
  };
}

export function guardedChatSend(otherUserId: string | undefined, run: () => void): void {
  const guard = otherUserId ? guards.get(otherUserId) : undefined;
  if (guard) guard(run);
  else run();
}
